const steps = [
  {
    number: '01',
    title: 'Submit Your Footage',
    description: 'Fill out our inquiry form and share your raw video files via a Google Drive or Dropbox link. No file size limits — just drop the link.',
    icon: 'ri-folder-upload-line',
  },
  {
    number: '02',
    title: 'We Review & Plan',
    description: 'Our editors review your footage, understand your brand, and map out the edit — music, pacing, captions, and style.',
    icon: 'ri-eye-line',
  },
  {
    number: '03',
    title: 'Editing & Production',
    description: 'We get to work — cutting, color grading, adding music, voiceovers, captions, and motion graphics to make it pop.',
    icon: 'ri-movie-2-line',
  },
  {
    number: '04',
    title: 'Delivery & Revisions',
    description: 'Your finished video is delivered within 48 hours. We offer revisions until you\'re 100% happy with the result.',
    icon: 'ri-send-plane-line',
  },
];

export default function HowItWorks() {
  return (
    <section className="py-24 bg-[#F8FAFF]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <span className="inline-block px-4 py-1.5 bg-[#1E3A8A]/10 text-[#1E3A8A] text-xs font-semibold rounded-full mb-4 tracking-widest uppercase">
            The Process
          </span>
          <h2 className="text-4xl font-bold text-gray-900 mb-4">Simple. Fast. Professional.</h2>
          <p className="text-gray-600 max-w-xl mx-auto text-base leading-relaxed">
            Getting your videos edited has never been easier. Just share your files and we handle the rest.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {steps.map((step, index) => (
            <div key={step.number} className="relative">
              {index < steps.length - 1 && (
                <div className="hidden lg:block absolute top-10 left-full w-full h-px bg-[#1E3A8A]/20 z-0" style={{ width: 'calc(100% - 2.5rem)', left: '2.5rem' }}></div>
              )}
              <div className="relative z-10 text-center">
                <div className="w-20 h-20 flex items-center justify-center bg-[#1E3A8A] rounded-2xl mx-auto mb-5 shadow-lg">
                  <i className={`${step.icon} text-2xl text-white`}></i>
                </div>
                <span className="text-xs font-bold text-[#1E3A8A] tracking-widest uppercase mb-2 block">{step.number}</span>
                <h3 className="text-lg font-bold text-gray-900 mb-3">{step.title}</h3>
                <p className="text-gray-600 text-sm leading-relaxed">{step.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
